import { render, staticRenderFns } from "./addorupdate.vue?vue&type=template&id=f4f60aae"
import script from "./addorupdate.vue?vue&type=script&lang=js"
export * from "./addorupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports